import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import Container from "../components/layout/Container";
import OtherAuctionCustomForm from "../components/OthersCustomFiledForm/OtherAuctionCustomForm";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const OthersAuctionCustomFiledForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"CREATING AUCTION LISTING"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <OtherAuctionCustomForm />
        </div>
      </div>
    </Container>
  );
};

export default OthersAuctionCustomFiledForm;
